module.exports = __webpack_public_path__ + "static/img/5.e999adc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/zh/5.png
// module id = 1l2H
// module chunks = 0